<script lang="ts" setup>
import { pinyin } from 'pinyin-pro';
import { computed } from 'vue';

const props = defineProps({
  text: {
    type: String,
    required: true
  }
});

const chars = computed(() => {
  const pinyinArray = pinyin(props.text, { type: 'array', toneType: 'symbol', nonZh: 'consecutive' });
  return props.text.split('').map((char, i) => ({
    char,
    pinyin: pinyinArray[i] ?? ''
  }));
});
</script>

<template>
  <span class="pinyin-line" v-if="props.text !== chars.map(item => item.pinyin).join('')">
    <span v-for="(item, i) in chars" :key="i" class="pinyin-wrapper">
      <span class="mr-1 pinyin-word">{{ item.pinyin }}</span>
    </span>
  </span>
</template>

<style lang="scss" scoped>
.pinyin-line {
  opacity: 0.5;
  bottom: 0px;
  left: 0px;
  word-break: break-all;
}
.pinyin-word {
  word-break: keep-all;
}
.pinyin-wrapper {
  ruby-position: under;
  display: inline-flex;
  font-size: 10px;
  rt {
    font-size: 0.6em;
    color: gray;
  }
}
</style>